import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing"; // legacy — kept available at /landing-legacy
import AdminPage from "./pages/AdminPage";
import ResultPage from "./pages/ResultPage";
import PrivacyPage from "./pages/PrivacyPage";
import MapaPage from "./pages/MapaPage";
import MapaCompletoPage from "./pages/MapaCompletoPage";
import AccederPage from "./pages/AccederPage";
import MiEvolucionPage from "./pages/MiEvolucionPage";
import LandingV2 from "./pages/LandingV2";
import EmpresasPage from "./pages/EmpresasPage";
import { Toaster } from "@/components/ui/sonner";
import { loadArchetypeCopy } from "@/data/results";

function App() {
  // Warm the archetype-copy cache on app mount so downstream consumers
  // (QuizDialog, ResultPage, IdentidadCard, MiEvolucionPage) can render
  // synchronously in the common case. Silent on failure — the hook
  // in each consumer will retry as needed.
  useEffect(() => {
    loadArchetypeCopy().catch(() => { /* noop — hooks handle retry */ });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Production landing — Apple Pro / Linear repositioning. */}
          <Route path="/" element={<LandingV2 />} />
          {/* Legacy landing — kept temporarily for rollback if needed. */}
          <Route path="/landing-legacy" element={<Landing />} />
          {/* Alias kept for previously-shared links during the transition. */}
          <Route path="/landing-v2" element={<LandingV2 />} />
          <Route path="/empresas" element={<EmpresasPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/r/:id" element={<ResultPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          {/* Premium maps — private, NOT linked from public navigation. */}
          <Route path="/mapa/:dominant/:secondary" element={<MapaPage />} />
          {/* Mapa Completo intent capture (email CTAs land here) */}
          <Route path="/mapa-completo/:leadId" element={<MapaCompletoPage />} />
          {/* Centro de Evolución — Magic Link auth (Sprint 1) */}
          <Route path="/acceder" element={<AccederPage />} />
          <Route path="/mi-evolucion" element={<MiEvolucionPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid #29BC9B33",
            color: "#FFFFFF",
          },
        }}
      />
    </div>
  );
}

export default App;
